import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DataFilter, DataService, ResourceMode, DataOrder } from '../../services/data.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { VisitCardStatus } from '../../services/visit-card.service';
import { VisitCardImageComponent } from '../../pg-ui-elements/visit-card-image/visit-card-image.component';
import { DateTime } from 'luxon';
import { NotificationsService } from '../../services/notifications.service';

@Component({
    selector: 'app-pg-visit-card-confirm',
    templateUrl: './pg-visit-card-confirm.component.html',
    styleUrls: ['./pg-visit-card-confirm.component.scss'],
    standalone: false
})
export class PgVisitCardConfirmComponent implements OnInit {

    constructor(private dataService:DataService, private modalService:NgbModal, private notificationsService:NotificationsService) { }

    @Input() resourceMode:'data'|'business';

    ngOnInit() {
        if(this.resourceMode == null) this.resourceMode = 'data'

        this.reset()
    }

    visitCardData:Array<VisitCardStatus> = null;

    isSettingVisitCardStatus:{ [id:string]: boolean } = {}

    setVisitCardStatus(request:VisitCardStatus, status:string) {
        let _mappedStatus = status == 'accept' ? 'confirmed' : status == 'refuse' ? 'canceled' : status;

        if(_mappedStatus != request.status) {
            this.isSettingVisitCardStatus[request.id] = true;
    
            this.dataService.putRequest('/' + this.resourceMode + '/visitCard/' + request.id + '/' + status, {}).subscribe((data) => {
                this.isSettingVisitCardStatus[request.id] = false;
    
                for(let i = 0; i < this.visitCardData.length; i++) {
                    if(this.visitCardData[i].id == request.id) {
                        this.visitCardData[i] = data;
                        break;
                    }
                }
            })
        }
    }

    supplierData:{ [id:string]: any } = {}

    pageNum = -1
    pageSize = 10

    isLoading = false;
    isAtEnd = false;

    reset() {
        this.pageNum = -1;
        this.isAtEnd = false;

        this.visitCardData = []

        this.loadData()
    }

    loadData() {
        if(!this.isLoading) {
            this.isLoading = true;
    
            this.pageNum ++;
    
            this.dataService.getResourceData('VisitCard', { 
                offset: this.pageNum * this.pageSize, 
                limit: this.pageSize + 1, 
                order: [{ field: 'id', direction: 'desc' }] 
            }, null, null, this.resourceMode).subscribe((data) => {
                let _supplierList:{ [resource:string]: Array<string> } = {}
                
                for(let i = 0; i < this.pageSize; i++) {
                    let _item = data[i]

                    if(_item != null) {
                        if(this.supplierData[_item.supplier] == null) {
                            let _split = _item.supplier.split('_')
                            let _resource = _split[0]
                            let _element = _split[1]

                            if(_supplierList[_resource] == null) _supplierList[_resource] = []
                            _supplierList[_resource].push(_element)
                        }

                        this.visitCardData.push(_item);
                    }
                }

                if(data.length <= this.pageSize) this.isAtEnd = true;

                let _reqCount = 0

                for(let i in _supplierList) {
                    _reqCount++;

                    this.dataService.getResourceData(i, { filter: [{ field: 'id', operator: 'in', value: _supplierList[i] }] }).subscribe((data) => {
                        for(let _item of data) {
                            this.supplierData[i + '_' + _item.id] = _item
                        }

                        _reqCount--;
                        if(_reqCount == 0) this.isLoading = false;
                    })
                }

                if(_reqCount == 0) this.isLoading = false;
            })
        }
    }

    @ViewChild('showVisitCardModal') showVisitCardModal:ElementRef

    private _showVisitCardModalRef:NgbModalRef

    showVisitCardModalRequest:VisitCardStatus = null;

    showVisitCardModalIsReady = false;

    showVisitCardModalOpen(request:VisitCardStatus) {
        this.showVisitCardModalRequest = request;

        this.showVisitCardModalIsReady = false;

        this.showVisitCardModalContactRecipient = null;
        this.showVisitCardModalContactVia = null;

        this._showVisitCardModalRef = this.modalService.open(this.showVisitCardModal, { size: 'lg' })
    }

    showVisitCardModalDismiss() {
        this._showVisitCardModalRef.dismiss()
    }

    @ViewChild(VisitCardImageComponent) showVisitCardModalImage:VisitCardImageComponent

    showVisitCardModalDownloadImage() {
        if(this.showVisitCardModalImage?.cardCanvasElement != null) {
            let _canvas = this.showVisitCardModalImage.cardCanvasElement.nativeElement as HTMLCanvasElement;

            let _link = document.createElement('a');
            _link.download = 'Visit Card ' + this.showVisitCardModalRequest.code + '.png';
            _link.href = _canvas.toDataURL()
            _link.click();
        }
    }

    showVisitCardModalContactRecipient:string = null;
    showVisitCardModalContactVia:string = null;

    showVisitCardModalIsSending = false;

    showVisitCardModalSendImage() {
        if(this.showVisitCardModalImage?.cardCanvasElement != null) {
            let _canvas = this.showVisitCardModalImage.cardCanvasElement.nativeElement as HTMLCanvasElement;

            this.showVisitCardModalIsSending = true;

            _canvas.toBlob((blob) => {
                let _file = new File([blob], 'Visit Card ' + this.showVisitCardModalRequest.code + '.png', { type: 'image/png' })

                this.dataService.postFile('File', _file, {
                    deadline: this.showVisitCardModalRequest.to
                    // TODO: qua si potrebbe aggiungere l'uso di metadata per identificare le immagini associate alla card per evitare di creare duplicati
                }).subscribe((data) => {
                    if(data.complete) {
                        if(data.error) {
                            this.showVisitCardModalIsSending = false;
                        }
                        else {
                            let _body:any = {
                                link: data.data.url,
                            }

                            if(this.showVisitCardModalContactVia) {
                                _body.contact = this.showVisitCardModalContactRecipient,
                                _body.contact_type = (this.showVisitCardModalContactVia == 'phone' ? 'SMS' : 'email')
                            }

                            this.dataService.postRequest('/data/visitCard/' + this.showVisitCardModalRequest.id + '/send', _body).subscribe((data) => {                                
                                this.notificationsService.addLocalNotification('pg-visit-card-confirm.visit-card-show-modal-send-successful', 'success', null, null, 3000)

                                setTimeout(() => {
                                    this.showVisitCardModalIsSending = false;
                                }, 3000)
                            }, () => {
                                this.showVisitCardModalIsSending = false;
                            })
                        }
                    }
                })
            })
        }
    }

    @ViewChild('createVisitCardModal') createVisitCardModal:ElementRef

    private _createVisitCardModalRef:NgbModalRef

    createVisitCardResource:'Host'|'ExperienceSupplier' = null;
    createVisitCardElement:string = null;
    createVisitCardFrom:string = null;
    createVisitCardTo:string = null;

    createVisitCardResourceSemantic = '{{name}}'

    createVisitCardResourceMode:ResourceMode = null;
    createVisitCardResourceFilter:Array<DataFilter> = null;
    createVisitCardResourceOrder:Array<DataOrder> = [{ field: 'name', direction: 'asc' }]

    createVisitCardModalOpen() {
        this.createVisitCardElement = null;
        
        if(this.resourceMode == 'business') {
            this.createVisitCardResource = 'Host';
            this.createVisitCardResourceMode = 'data'
            this.createVisitCardResourceFilter = [
                { field: 'visit_card_supplier', operator: '==', value: [true] },
                { field: 'published', operator: '==', value: [true] }
            ]
        }
        else {
            this.createVisitCardResource = 'ExperienceSupplier';
            this.createVisitCardResourceMode = 'public'
            this.createVisitCardResourceFilter = [{ field: 'visit_card_supplier', operator: '==', value: [true] }]
        }

        let _date = new Date();

        this.createVisitCardFrom = DateTime.fromJSDate(_date).toFormat('yyyy-LL-dd');

        _date.setDate(_date.getDate() + 7) 

        this.createVisitCardTo = DateTime.fromJSDate(_date).toFormat('yyyy-LL-dd');

        this._createVisitCardModalRef = this.modalService.open(this.createVisitCardModal)
    }

    createVisitCardModalDismiss() {
        this._createVisitCardModalRef.dismiss()
    }

    createVisitCardModalIsSaving = false;

    createVisitCardModalSubmit() {
        this.createVisitCardModalIsSaving = true

        this.dataService.postRequest('/data/visitCard', {
            from: new Date(this.createVisitCardFrom).toISOString(),
            to: new Date(this.createVisitCardTo).toISOString(),
            supplier: this.createVisitCardResource + '_' + this.createVisitCardElement,
            status: 'confirmed',
            backoffice_created: true
        }).subscribe((data) => {
            this.createVisitCardModalIsSaving = false;

            this.createVisitCardModalDismiss();

            this.reset()
        }, () => {
            this.createVisitCardModalIsSaving = false;
        })
    }
}
